import { render, staticRenderFns } from "./permission-container.vue?vue&type=template&id=33b35eae&"
import script from "./permission-container.vue?vue&type=script&lang=tsx&"
export * from "./permission-container.vue?vue&type=script&lang=tsx&"
import style0 from "./permission-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports